<div>
  <span *ngFor="let breadcrumb of breadcrumbs">
    <span>/ {{ breadcrumb.label }}</span>
  </span>
</div>
